import { useCallback } from "react";
import { ProfileTab } from "../psychologist/tabs";
import { usePsychologistData } from "../../hooks/usePsychologistData";
import { useAppShell } from "../../contexts/AppShellContext";

export const ProfilePage = () => {
  const psychologist = usePsychologistData();
  const { setProfileDirty } = useAppShell();

  const handleDirtyChange = useCallback((dirty: boolean) => {
    setProfileDirty(dirty);
  }, [setProfileDirty]);

  return (
    <ProfileTab
      psychologist={psychologist}
      onDirtyChange={handleDirtyChange}
    />
  );
};
